module.exports = __webpack_public_path__ + "static/media/neighbourhood-02-skytrain.8b730408.jpg";